module.exports = __webpack_public_path__ + "img/veronica.aa3453f0.webp";